import { createAction, props } from '@ngrx/store';
import { Module } from 'src/app/models/module.model';
import { UserMeInput, UserMeOutput } from 'src/app/models/users.model';
import {Client, ClientUserOutput} from "../../models/client.model";
// import {EmployeeDto, EmployeeMeInputDto} from '../../shared/models/employee.models';
// import {Client} from '../../shared/models/client';
// import {CompanyOutputDto} from '../../shared/models/company.models';
// import {TransportMeanInputDto, TransportMeanOutputDto} from '../../shared/models/transportmeans.models';
// import {TravelInformationDto} from '../../shared/models/travel.models';
// import {PoolingPreferenceDto} from '../../shared/models/mPooling.models';


export const loadingStart = createAction('[General] Loading start');
export const loadingEnd = createAction('[General] Loading end');


export const loadingProfile = createAction('[Profile] Loading Profile');
export const loadedProfile = createAction('[Profile] Loaded Profile', props<{ profile: UserMeOutput }>());
export const loadingProfileFailed = createAction('[Profile] Loading Profile Failed');

export const updatingProfile = createAction('[Profile] Updating Profile', props<{ profile: UserMeInput }>());
export const updatedProfile = createAction('[Profile] Updated Profile', props<{ profile: UserMeOutput }>());
export const updatingProfileFailed = createAction('[Profile] Updating Profile Failed');

export const updatingAvatar = createAction('[Avatar] Updating Avatar', props<{ file: File }>());
export const updatedAvatar = createAction('[Avatar] Updated Avatar', props<{ avatar: {url?: string | undefined } }>());
export const updatingAvatarFailed = createAction('[Avatar] Updating Avatar Failed');

export const loadingMyPoints = createAction('[Points] Loading Points');
export const loadedMyPoints = createAction('[Points] Loaded Points', props<{ myPoints: number }>());
export const loadingMyPointsFailed = createAction('[Points] Loading Points Failed');

export const loadingModules = createAction('[Client] Loading Modules');
export const loadedModules = createAction('[Client] Loaded Modules', props<{modules: Module[] | undefined}>());
export const loadingModulesFailed = createAction('[Client] Loaded Modules Failed');

// export const deactivatingUser = createAction('[User] Deactivating User');
// export const deactivateUser = createAction('[User] Deactivate User');
// export const deactivatingUserFailed = createAction('[User] Deactivate User failed');
// export const addingMezzo = createAction('[Employee] Adding Mezzo', props<{ mezzo: TransportMeanInputDto }>());
// export const addingMezzoToProfileFailed = createAction('[Employee] Adding Mezzo failed');
// export const updatedMezzi = createAction('[Employee] Updated Mezzi', props<{ mezzi: TransportMeanOutputDto[] }>());
//
// export const updatedTravelInformation = createAction('[Employee] Updated TravelInformation', props<{ travelInformation: TravelInformationDto }>());
//
//
//
// export const profileDipendenteCompleted = createAction('[Employee] Profile Dipendente Completed');
// export const profileDipendenteUncompleted = createAction('[Employee] Profile Dipendente Uncompleted');
// export const setProfileDipendenteCompleted = createAction('[Employee] Set Profile Dipendente Completed', props<{ completed: boolean }>());
//
// export const updatingEmployeePoolingPreferences = createAction('[Employee] Updating Employee Pooling Preferences', props<{ preferences: PoolingPreferenceDto }>());
// export const updatedEmployeePoolingPreferences = createAction('[Employee] Updated Employee Pooling Preferences', props<{ preferences: PoolingPreferenceDto }>());
// export const updatingEmployeePoolingPreferencesFailed = createAction('[Employee] Updating Employee Pooling Preferences Failed');
//
// export const profileDipendenteToOfferPassCompleted = createAction('[Employee] Profile Dipendente To Offer Pass Completed');
// export const profileDipendenteToOfferPassUncompleted = createAction('[Employee] Profile Dipendente To Offer Pass Uncompleted');
// export const setProfileDipendenteToOfferPassCompleted = createAction('[Employee] Set Profile Dipendente To Offer Pass Completed', props<{ completed: boolean }>());
//
//
// export const updateProfile = createAction('[Employee] Update Profile', props<{ employee: EmployeeMeInputDto }>());
// export const updateProfileCompleted = createAction('[Employee] Update Profile Completed', props<{update: EmployeeMeInputDto}>());
// export const updateProfileFailed = createAction('[Employee] Update Profile Failed');
//
//
export const loadingClient = createAction('[Client] Loading Client');
export const loadClientCompleted = createAction('[Client] Load Client Completed', props<{client: ClientUserOutput | undefined}>());
export const loadClientFailed = createAction('[Client] Load Client Failed');
//
// export const loadingCompany = createAction('[Company] Loading Company');
// export const loadCompanyCompleted = createAction('[Company] Load Company Completed', props<{company: CompanyOutputDto |undefined}>());
// export const loadCompanyFailed = createAction('[Company] Load Company Failed');
